import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.APP_SETTINGS_TABLE;

async function getAppSettings() {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        fetchAll: true
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getAppSettings
};
